<template>
    <div class="container mx-auto">
        <div class="flex flex-col">
            <div v-if="isDoneWithoutErrors()" class="flex flex-col w-11/12 mx-auto mb-5 md:w-8/12 lg:w-6/12">
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" class="h-24 my-auto fill-current text-green-200">
                    <path d="M173.898 439.404l-166.4-166.4c-9.997-9.997-9.997-26.206 0-36.204l36.203-36.204c9.997-9.998 26.207-9.998 36.204 0L192 312.69 432.095 72.596c9.997-9.997 26.207-9.997 36.204 0l36.203 36.204c9.997 9.997 9.997 26.206 0 36.204l-294.4 294.401c-9.998 9.997-26.207 9.997-36.204-.001z"></path>
                </svg>
                <div class="mb-5 text-2xl text-center text-white text-medium scroll-margin-top-header">
                    Bedankt voor uw aanmelding!
                </div>
            </div>
            <div v-else class="flex flex-col w-11/12 mx-auto mb-5 md:w-8/12 lg:w-6/12">
                <h2 class="mb-5 text-2xl text-center text-white text-medium scroll-margin-top-header" id="aanmelden">Blijf op de hoogte!</h2>
                <div class="flex flex-wrap leading-none">
                    <form class="flex flex-wrap w-full leading-none" @submit.prevent="subscribe">
                        <label class="sr-only" for="emailaddress">Emailadres:</label>
                        <div class="w-8/12 overflow-hidden rounded-tl sm:w-9/12" :class="{'border-2 border-red' : isDoneWithErrors()}">
                            <input id="emailaddress" ref="emailinput" class="w-full p-2 pl-4 text-gray-800 rounded-l" type="email" placeholder="Uw e-mailadres" v-model="email" required>
                        </div>
                        <button type="submit" class="w-4/12 px-3 py-2 font-medium bg-green-200 rounded-r sm:w-3/12 hover:bg-orange text-white">
                            <span v-if="!loading">aanmelden</span>
                            <span v-else>Bezig...</span>
                        </button>

                        <div v-if="status" class="w-8/12 overflow-hidden border-2 rounded-b sm:w-9/12" :class="{'border-red' : isDoneWithErrors(), 'border-green-100' : isDoneWithoutErrors()}">
                            <div :class="{'bg-red': isDoneWithErrors(), 'bg-green-100': isDoneWithoutErrors()}">
                                <div class="flex p-2" v-if="!loading && status">
                                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" class="inline h-4 my-auto fill-current" :class="{'text-white': isDoneWithErrors(), 'text-green-200': isDoneWithoutErrors()}">
                                        <path v-if="isDoneWithErrors()" d="M242.72 256l100.07-100.07c12.28-12.28 12.28-32.19 0-44.48l-22.24-22.24c-12.28-12.28-32.19-12.28-44.48 0L176 189.28 75.93 89.21c-12.28-12.28-32.19-12.28-44.48 0L9.21 111.45c-12.28 12.28-12.28 32.19 0 44.48L109.28 256 9.21 356.07c-12.28 12.28-12.28 32.19 0 44.48l22.24 22.24c12.28 12.28 32.2 12.28 44.48 0L176 322.72l100.07 100.07c12.28 12.28 32.2 12.28 44.48 0l22.24-22.24c12.28-12.28 12.28-32.19 0-44.48L242.72 256z"></path>
                                        <path v-if="isDoneWithoutErrors()" d="M173.898 439.404l-166.4-166.4c-9.997-9.997-9.997-26.206 0-36.204l36.203-36.204c9.997-9.998 26.207-9.998 36.204 0L192 312.69 432.095 72.596c9.997-9.997 26.207-9.997 36.204 0l36.203 36.204c9.997 9.997 9.997 26.206 0 36.204l-294.4 294.401c-9.998 9.997-26.207 9.997-36.204-.001z"></path>
                                    </svg>
                                    <span class="my-auto ml-2" :class="{'text-white': isDoneWithErrors(), 'text-green-200': isDoneWithoutErrors()}">{{ status }}</span>
                                </div>
                            </div>
                        </div>
                    </form>

                </div>
                <div class="w-full sm:w-8/12 mx-auto pt-6 text-xs leading-7 text-center text-white" v-html="mailertext"></div>
            </div>

        </div>
    </div>
</template>
<script>
    import jsonp from 'jsonp';
    import queryString from 'query-string';

    export default {
        name: "MailchimpOptin",
        props: {
            url: {
                required: true,
                type: String,
            },

            userId: {
                required: true,
                type: String,
            },

            listId: {
                required: true,
                type: String,
            },
            mailertext: String
        },
        data: function(){
            return {
                email: null,
                success: false,
                status: null,
                statusClass: '',
                loading: false,
            }
        },
        methods: {
            subscribe() {
                if (this.email === null || this.loading) {
                    return
                }

                this.success = false;
                this.status = null;
                this.loading = true;

                jsonp(this.url + `?${this.formData}`, { param: 'c' }, this.onResponse)
            },

            onResponse(error, data) {
                this.loading = false;

                if (error) {
                    this.status = error
                }

                if (data && data.result === 'error') {
                    this.status = this.formatErrorMessage(data.msg);
                    this.$refs.emailinput.focus();
                }

                if (!this.status) {
                    this.success = true;
                    this.status = 'U heeft zich met succes aangemeld!';
                    this.email = null;
                }
            },

            formatErrorMessage(message) {
                if (message.includes('too many recent signup requests')) {
                    return "U heeft recent te vaak geprobeerd aan te melden voor de nieuwsbrief, probeer het later opnieuw.";
                } else if (message.includes('Too many subscribe attempts for this email address')) {
                    return "Er zijn te veel mensen die zich tegelijkertijd proberen aan te melden, probeer het later opnieuw.";
                } else if (message.includes('is already subscribed')) {
                    return "U bent reeds aangemeld voor de nieuwsbrief. Bedankt voor uw aanmelding!";
                } else if (message.includes('An email address must contain a single @') || message.includes('The domain portion of the email address is invalid')) {
                    return "Het ingevulde email adres is niet correct!";
                } else {
                    return "Er is een onbekende fout opgetreden, probeer het later opnieuw.";
                }
            },
            isDoneWithoutErrors() {
                return this.success && !this.isLoading && this.status;
            },
            isDoneWithErrors() {
                return !this.success && !this.isLoading && this.status;
            },
        },
        computed: {
            formData() {
                return queryString.stringify({
                    u: this.userId,
                    id: this.listId,
                    EMAIL: this.email,
                })
            },
        },
    }
</script>
